import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Navigate 
} from "react-router-dom";


import OpticalAdminLayout from "./components/Layout";
import AdminLogin from "./Pages/LoginPage";
import Dashboard from "./Pages/Dashboard";
import StoreList from "./Pages/StoreManagement";
import SubscriptionApproval from "./Pages/SubscriptionApproval";
import SubscriptionPlans from "./Pages/SubscriptionPlans";
import SuperAdminPaymentHistoryScreen from "./Pages/PaymentHistory";
import SuperAdminReports from "./Pages/ReportsPage";
import Categories from "./Pages/Categories";
import Brands from "./Pages/Brands";
import MasterProducts from "./Pages/Products";
import ExpenseTracker from "./Pages/Expensestracker ";
import EcommerceCMS from "./Pages/EcommerceCMS";
import ClinicalDropdowns from "./Pages/ClinicalDropdowns";
import SuspendedPage from "./Pages/SuspendedPage";
import StoreDirectory from "./Pages/StoreDirectory";





function App() {

  return (

    <Router>

      <Routes>


        {/* Redirect root */}

        <Route 
          path="/" 
          element={<Navigate to="/adminlogin" />} 
        />



        {/* Login */}

        <Route 
          path="/adminlogin" 
          element={<AdminLogin />} 
        />


        {/* <Route 
          path="/forgotpassword" 
          element={<AdminForgotPassword />} 
        /> */}




        {/* SUPER ADMIN ROUTES */}

        <Route 
          path="/admin" 
          element={<OpticalAdminLayout />}
        >


          {/* Dashboard */}

          <Route 
            path="dashboard" 
            element={<Dashboard />} 
          />



          {/* Store Management */}

          <Route 
            path="store-directory" 
            element={<StoreDirectory />} 
          />

          <Route 
            path="stores" 
            element={<StoreList/>} 
          />



          {/* User Management */}

          {/* <Route 
            path="users" 
            element={<Users />} 
          /> */}




          <Route 
            path="subscriptions" 
            element={<SubscriptionApproval/>} 
          />


<Route 
            path="subscriptionsplans" 
            element={<SubscriptionPlans/>} 
          />
          <Route 
            path="Paymenthistory" 
            element={<SuperAdminPaymentHistoryScreen/>} 
          />


          <Route 
            path="reports" 
            element={<SuperAdminReports />} 
          />
 <Route 
            path="categories" 
            element={<Categories />} 
          />
 <Route 
            path="brands" 
            element={<Brands />} 
          />


 <Route 
            path="products" 
            element={<MasterProducts />} 
          />

          <Route 
            path="ecommerce-cms" 
            element={<EcommerceCMS />} 
          />


          {/* Suspended Routes (Access via direct link is disabled) */}
          <Route 
            path="orders" 
            element={<SuspendedPage moduleName="Purchase Orders" />} 
          />
          <Route 
            path="patients" 
            element={<SuspendedPage moduleName="Patients" />} 
          />
          <Route 
            path="eyeexam" 
            element={<SuspendedPage moduleName="Eye Exams" />} 
          />
          <Route 
            path="new-eye-examination" 
            element={<SuspendedPage moduleName="New Eye Examination" />} 
          />
          <Route 
            path="opticalsales" 
            element={<SuspendedPage moduleName="Optical Sales" />} 
          />
          <Route 
            path="new-order" 
            element={<SuspendedPage moduleName="New Order" />} 
          />
          <Route 
            path="followup" 
            element={<SuspendedPage moduleName="Follow-up Reminders" />} 
          />
          <Route 
            path="stockinventory" 
            element={<SuspendedPage moduleName="Stock Inventory" />} 
          />
          <Route 
            path="add-stock" 
            element={<SuspendedPage moduleName="Add Stock" />} 
          />
          <Route 
            path="billing" 
            element={<SuspendedPage moduleName="Billing & POS" />} 
          />
            <Route 
            path="expensetracker" 
            element={<ExpenseTracker/>} 
            
          />
          <Route 
            path="clinical-dropdowns" 
            element={<ClinicalDropdowns />} 
          />
          <Route 
            path="dropdown-settings" 
            element={<ClinicalDropdowns />} 
          />
          {/* Settings */}

          {/* <Route 
            path="settings" 
            element={<Settings />} 
          /> */}



        </Route>





        {/* 404 */}

        <Route 
          path="*" 
          element={<h2>Page Not Found</h2>} 
        />



      </Routes>


    </Router>

  );

}


export default App;